import { create } from 'zustand';
import { useTokenStore } from './setTokenStore';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { AuthApi, type LoginRequest, type LoginResponse } from '@shared/api';

interface UseLoginStore {
  data: LoginResponse | null;
  error: string | null;
  success: boolean | null;
  loading: boolean;
  login: (request: LoginRequest, signal?: AbortSignal) => Promise<void>;
  resetErrors: () => void;
  clear: () => void;
}

export const useLoginStore = create<UseLoginStore>((set) => ({
  loading: false,
  data: null,
  error: null,
  success: false,

  login: ApiUtils.wrapperApi(async (data) => {
    try {
      set({ loading: true, success: null, error: null });
      const response = await AuthApi.login(data);
      if (response.token) useTokenStore.getState().setToken(response.token);
      set({ success: true, data: response, loading: false });
    } catch (error) {
      set({ success: null, error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  resetErrors: () => set({ error: null }),

  clear: () => set({ data: null, error: null, success: false, loading: false }),
}));
